import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4 w-full p-2"
}
const _hoisted_2 = { class: "flex flex-row items-center gap-4" }

import { watch, ref, onMounted } from "vue";
import { toRef } from "vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/stores/user";
import { InvestmentRequest, Record } from "@/services/invest/types";
import { InvestmentService } from "@/services/invest/investmentService";
import Switch from "@/components/atoms/Switch.vue";
import NewModal from "../atoms/NewModal.vue";
import FormInvestiment from "../molecules/FormInvestiment.vue";
import FormRecord from "../molecules/FormRecord.vue";

import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'EntityRecordSettingsModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:visible", "reload"],
  setup(__props, { emit }) {

const props = __props;





const setEntitySettingsRequestResponse = ref<any>({});

const userStore = useUserStore();
const { entitySettings } = storeToRefs(userStore);
const investmentService = new InvestmentService();

const handleSetEntitySettingsForm = async () => {
  setEntitySettingsRequestResponse.value =
    await investmentService.setEntitySettings(
      entitySettings?.value?.id,
      entitySettings?.value?.allFields
    );
};

watch(props, () => {
  if (props.visible) {
    userStore.fetchEntitySettings("SHAREHOLDER", "InvestmentRecord");
  }
});

watch(setEntitySettingsRequestResponse, () => {
  if (setEntitySettingsRequestResponse.value.code == 200) {
    Swal.fire("Listo!", "Campos visibles editados correctamente", "success");
    emit("update:visible");
  } else {
    Swal.fire("Error", "Oops, hubo un error", "error");
    console.log("Hubo un error!");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NewModal, {
      title: "Configurar Visibilidad del detalle de invesión",
      visible: __props.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = (e) => _ctx.$emit('update:visible', e))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('update:visible')),
            type: "button",
            class: "flex flex-row items-center rounded-full px-4 py-2 bg-gray-400 transition text-sm shadow text-white"
          }, " Cancelar "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSetEntitySettingsForm())),
            type: "button",
            class: "btn"
          }, " Guardar ")
        ])
      ]),
      default: _withCtx(() => [
        (_unref(entitySettings) != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entitySettings).allFields, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-row justify-between gap-4 items-center",
                  key: field.name
                }, [
                  _createElementVNode("p", null, _toDisplayString(field.description), 1),
                  _createVNode(Switch, {
                    actived: field.checked,
                    "onUpdate:actived": 
              () => {
                field.checked = !field.checked;
              }
            
                  }, null, 8, ["actived", "onUpdate:actived"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})